//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { NewsPublishLocations } from './NewsPublishLocations';

export class NewsSearchOptions extends ItemBase {
    IDs: string[] = [];
    PublishLocations: NewsPublishLocations | null = null;
    Month: string | null = null;
    Categories: string[] = [];
    StartDate: string | null = null;
    EndDate: string | null = null;
    Sticky: boolean | null = null;
    Editable: boolean | null = null;
    SearchText: string | null = null;

    constructor(initializer?: Partial<NewsSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "NewsSearchOptions";
}
